import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const products = [
  {
    n: "M.01",
    name: "ADS LOGO TEE / BLACK",
    price: "$38",
    img: "/ads-logo.png",
  },
  {
    n: "M.02",
    name: "NO SLEEP WORKSHIRT",
    price: "$52",
    img: "https://images.unsplash.com/photo-1503341504253-dff4815485f1?auto=format&fit=crop&w=1000&q=80",
  },
  {
    n: "M.03",
    name: "WAREHOUSE HOODIE",
    price: "$74",
    img: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&w=1000&q=80",
  },
  {
    n: "M.04",
    name: "SIGNAL TEE / WHITE",
    price: "$38",
    img: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?auto=format&fit=crop&w=1000&q=80",
  },
];

export default function Merch() {
  return (
    <section id="merch" data-testid="merch-section" className="border-b border-white/15">
      <div className="px-4 sm:px-8 py-20 sm:py-28">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono-x text-[11px] tracking-[0.3em] text-white/40 uppercase mb-4"
          data-testid="merch-overline"
        >
          [03] — MERCH
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono-x font-extrabold uppercase tracking-tighter leading-[0.9] text-4xl sm:text-6xl mb-14"
          data-testid="merch-title"
        >
          UNIFORM FOR
          <br />
          <span className="text-stroke">THE NIGHT SHIFT</span>
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/15">
          {products.map((p, i) => (
            <motion.article
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group border-r border-b border-white/15"
              data-testid={`merch-item-${p.n.toLowerCase().replace(".", "-")}`}
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-neutral-950">
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className={`w-full h-full ${p.img.startsWith("/") ? "object-contain p-8 bg-black" : "object-cover"} grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-500`}
                />
                <span className="absolute top-4 left-4 font-mono-x text-[10px] tracking-[0.25em] text-[#ff3b1d] bg-black/70 px-2 py-1">
                  {p.n}
                </span>
              </div>
              <div className="px-5 py-4 border-t border-white/15 group-hover:bg-white transition-colors duration-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-mono-x text-xs sm:text-sm font-bold uppercase tracking-tight group-hover:text-black transition-colors duration-200">
                    {p.name}
                  </h3>
                  <span className="font-mono-x text-xs text-white/60 group-hover:text-black transition-colors duration-200">
                    {p.price}
                  </span>
                </div>
                <a
                  href="#booking"
                  data-testid={`merch-enquire-${p.n.toLowerCase().replace(".", "-")}`}
                  className="inline-flex items-center gap-2 font-mono-x text-[10px] tracking-[0.25em] text-white/50 group-hover:text-[#ff3b1d] transition-colors duration-200"
                >
                  ENQUIRE <ArrowUpRight size={12} />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
